import { EventRegistry } from '../../../../../domain/event/event.registry';
import { ReferenceTableEvent } from './reference-table.event';
export class ReferenceTableDescriptionSetEvent extends ReferenceTableEvent {
    constructor(payload, metadata, fromPersistence) {
        super({
            subject: `reference-table/${payload.id}`,
            type: ReferenceTableDescriptionSetEvent.type,
            payload,
            metadata,
            fromPersistence,
        });
    }
}
ReferenceTableDescriptionSetEvent.subject = 'reference-table/aggregate/reference-table/ReferenceTableDescriptionSetEvent';
ReferenceTableDescriptionSetEvent.type = 'com.treeplotter.api.reference-table.descriptionSet.v1';
EventRegistry.register(ReferenceTableDescriptionSetEvent.type, ReferenceTableDescriptionSetEvent);
//# sourceMappingURL=reference-table-description-set.event.js.map